import { useAppDispatch, useAppSelector } from "../../app/hooks";
import Grid2 from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import {
  loginAsync,
  onEmailChanged,
  onPasswordChanged,
  selectState,
} from "./LoginPageSlice";
import {
  Box,
  Button,
  Container,
  useMediaQuery,
  useTheme,
  TextField,
  Typography,
} from "@mui/material";

export function LoginPage() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const state = useAppSelector(selectState);
  const theme = useTheme();
  const lessThanSm = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Container maxWidth="sm" disableGutters={lessThanSm}>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Grid2
          container
          spacing={2}
          sx={{ mt: 2 }}
          columns={{ xs: 6, sm: 6, md: 12 }}
        >
          <Grid2 size={12}>
            <TextField
              fullWidth
              label="Email"
              variant="outlined"
              type="email"
              color="info"
              value={state.email}
              onChange={(e) => dispatch(onEmailChanged(e.target.value))}
            />
          </Grid2>
          <Grid2 size={12}>
            <TextField
              fullWidth
              type="password"
              label="Password"
              variant="outlined"
              color="info"
              value={state.password}
              onChange={(e) => dispatch(onPasswordChanged(e.target.value))}
            />
          </Grid2>
          <Grid2 size={12}>
            <Button
              component="label"
              variant="contained"
              sx={{ textTransform: "none" }}
              onClick={(e: any) => {
                dispatch(loginAsync(navigate));
              }}
            >
              <Typography variant="h5">Login</Typography>
            </Button>
          </Grid2>
        </Grid2>
      </Box>
    </Container>
  );
}
